export type Severity = "warning" | "critical" | null;

export const severityStyles = {
  warning: {
    borderColor: "#f9a825",
    color: "#f9a825"
  },
  critical: {
    borderColor: "#d32f2f",
    color: "#d32f2f"
  }
} as const;

export const getSeverity = (vitalName?: string, reading?: string): Severity | null => {
  if (!vitalName || !reading) return null;

  switch (vitalName) {
    case "bloodPressure": {
      // normal: 120/80
      const [sys, dia] = reading.split("/").map(Number);
      if (!sys || !dia) return null;

      // Hypertensive crisis
      if (sys >= 180 || dia >= 120) return "critical";

      // Hypertension (elevated / stage 1 / stage 2)
      if (sys >= 130 || dia >= 80) return "warning";

      return null;
    }

    case "pulse": {
      // normal value: 60-100
      const val = Number(reading);

      if (val < 40 || val > 150) return "critical";
      if (val < 60 || val > 100) return "warning";

      return null;
    }

    case "temperature": {
      // normal: 97-99°F
      const val = Number(reading);
      if (val < 95 || val > 104) return "critical";
      if (val < 97 || val > 99) return "warning";
      return null;
    }

    case "glucoseLevel": {
      // Normal: 70–180 mg/dL
      const val = Number(reading);

      // Severe hypo/hyperglycemia
      if (val < 54 || val > 400) return "critical";

      // Hypoglycemia or hyperglycemia needing action
      if (val < 70 || val > 250) return "warning";

      return null;
    }

    case "saturation":
    case "SPO2": {
      // Normal: 95-100
      const val = Number(reading.replace("%", ""));

      // Severe hypoxemia
      if (val < 85) return "critical";

      //  Mild hypoxemia
      if (val < 95) return "warning";

      return null;
    }

    default:
      return null;
  }
};
